import type { CaptionListenerApi, AppStartListening } from '../helpers/types';
import { startCaptionsSessionIfReady } from '../helpers/captionSession';

import type { RootState } from 'features/app/store/store';
import {
  clearCaptions,
  selectAreCaptionsBlockedBySignMail,
  stopCaptionsSessionThunk,
} from 'features/call/call-captions/store';

const didCaptionBlockChange = (
  currentState: RootState,
  previousState: RootState
) =>
  selectAreCaptionsBlockedBySignMail(currentState) !==
  selectAreCaptionsBlockedBySignMail(previousState);

// SignMail placement and AST handoff: clear lines and stop while blocked;
// restart when the block lifts if intent is still on.
const syncCaptionSessionWithSignMailBlock = async (api: CaptionListenerApi) => {
  if (selectAreCaptionsBlockedBySignMail(api.getState())) {
    api.dispatch(clearCaptions());
    await api.dispatch(
      stopCaptionsSessionThunk({ source: 'signmail-disable' })
    );
    return;
  }

  await startCaptionsSessionIfReady(api, 'signmail-enable');
};

export const registerCaptionBlockingListeners = (
  startListening: AppStartListening
) => {
  // Any action that flips the block is enough. Do not list
  // recordingErrorOccurred, mailBoxIsFull, _resetSignMail, and the rest.
  startListening({
    predicate: (_action, currentState, previousState) =>
      didCaptionBlockChange(currentState, previousState),
    effect: async (_action, api) => {
      await syncCaptionSessionWithSignMailBlock(api);
    },
  });
};
